<script>
</script>

<style>

	.slate {
		flex: 1 0 auto;
		margin: 0 auto;
		padding: 3rem 2rem;
	}
	.slate :global(p) {
		margin: 0.6rem auto 0 auto;
		font-size: 1rem;
		max-width: 18rem;
		line-height: 1.4;
		text-align: left;
		color: var(--textColor);
	}
	.slate :global(.icon svg) {
		/*width: 2.6rem;
		height: 2.6rem;*/
		width: 4rem;
		height: 4rem;
	}
	.slate :global(.label) {
		font-size: 1.3rem;
	}
	.slate :global(p) {
		font-size: 1rem;
	}

	.slate :global(.bigtick) {
		text-align: left;
	}

	.slate :global(.bigtick svg) {
		width: var(--size);
		height: var(--size);
	}

</style>

<div class="slate">
	<slot/>
</div>